<script setup lang="ts">
import device from '@@/bits/device'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzPadletLogo from '@@/library/v4/components/OzPadletLogo.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import SurfaceMapPostListVertical from '@@/vuecomponents/SurfaceMapPostListVertical.vue'
import SurfaceTitleMap from '@@/vuecomponents/SurfaceTitleMap.vue'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

withDefaults(
  defineProps<{
    isShown?: boolean
  }>(),
  {
    isShown: false,
  },
)

defineEmits(['start-reordering', 'stop-reordering'])

const surfaceStore = useSurfaceStore()
const { backgroundLuminance, colorScheme, homeUrl, isScreenshotMode } = storeToRefs(surfaceStore)
const { resizeHeader } = surfaceStore

onMounted(async (): Promise<void> => {
  resizeHeader({ height: 0 })
})
</script>

<template>
  <div
    :class="[
      'fixed z-10 top-0 start-4',
      'flex flex-col',
      'overflow-hidden box-border h-full pb-17.5',
      'pointer-events-none',
    ]"
  >
    <OzPadletLogo
      v-if="!device.app"
      :class="[
        'ms-1 mt-4.5',
        'w-12 h-3',
        // This is a hack because in surface
        // the inherited line height is 20px.
        // Since we want 12px height, we also
        // need to set line height to 12px.
        'leading-3',
        'pointer-events-auto',
        isScreenshotMode && 'invisible',
      ]"
      :href="homeUrl"
      :dark-mode="colorScheme === 'dark'"
    />
    <OzBox
      id="surface-header"
      :class="[
        'flex flex-col',
        'overflow-hidden',
        'box-border',
        'mt-4.5',
        'w-80',
        'pt-3.5',
        !isShown && 'pb-4',
        'pointer-events-auto',
      ]"
      :color="OzBoxColors.PrimaryBlur"
      :dark-mode="colorScheme === 'dark'"
      :radius="16"
    >
      <SurfaceTitleMap class="mx-4" />
      <SurfaceMapPostListVertical
        :class="[
          'overflow-y-auto',
          'pt-2',
          {
            'scrollbar-regular': colorScheme === 'light',
            'scrollbar-regular-dark': colorScheme === 'dark',
          },
        ]"
        :is-shown="isShown"
        @start-reordering="$emit('start-reordering')"
        @stop-reordering="$emit('stop-reordering')"
      />
    </OzBox>
  </div>
</template>
